import { render } from "./ApprovalsPage.vue?vue&type=template&id=85826aea&scoped=true"
import script from "./ApprovalsPage.vue?vue&type=script&lang=js"
export * from "./ApprovalsPage.vue?vue&type=script&lang=js"

import "./ApprovalsPage.vue?vue&type=style&index=0&id=85826aea&scoped=true&lang=css"

import exportComponent from "/home/acartia-ops/acartia/src/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85826aea"]])

export default __exports__